<template lang='pug'>
    div
        PDaccessoriesSelectorLinks
        div.fullwidth(v-if="$route.params.lang == 'en'")

            section.title-container
                h1.product-title Flange Adapters
                h2.product-subtitle Adapters for drain valves with higher diameter

            section.margin-bottom
                .column-container
                    .column.center-content
                        picture.main-product-picture
                            source(type='image/webp', srcset='@/assets/photos/FlangeAdapter.webp')
                            img( src='@/assets/photos/FlangeAdapter.png', width="70%", alt='Flange Adapter for higher diameters', title='Flange Adapter for higher diameters')
                    .column.factsandbluebox
                        .factbox
                            span.headline Key Features:
                            ul
                                li Adapters for Drain Valve Sensors
                                li Various Adapters available
                                li Custom Designs possible
                                
                        .bluebox
                            Maillink(to='support@bss-hs.de', sub='Flange Adapter', text='Contact Us', size=30, strokeWidth=2)
                            Sitelink(to="/en/products/uhfsensors/overview", text='UHF Sensors')
            section.margin-bottom
                p Adapter flange for the UHF-DVS-50 sensor, designed to allow installation on drain valves with larger diameters. The pitch circle is compatible with DN50 and DN100. Machined from aluminum. Available upon request.  

        div.fullwidth(v-if="$route.params.lang == 'de'")

            section.title-container
                h1.product-title Flanschadapter
                h2.product-subtitle Adaptierungen für Ölschieber mit größerem Durchmesser
            
            section.margin-bottom
                .column-container
                    .column.center-content
                        picture.main-product-picture
                            source(type='image/webp', srcset='@/assets/photos/FlangeAdapter.webp')
                            img( src='@/assets/photos/FlangeAdapter.png', width="70%", alt='Adaptierungen für größere Durchmesser', title='Adaptierungen für größere Durchmesser')
                    .column.factsandbluebox
                        .factbox
                            span.headline Highlights:
                            ul
                                li Adapter für Schiebesensoren
                                li Verschiedene Typen verfügbar
                                li Anfertigung nach Kundenwunsch möglich
                            
                        .bluebox
                            Maillink(to='support@bss-hs.de', sub='Flanschadapter', text='Kontakt', size=30, strokeWidth=2)
                            Sitelink(to="/de/products/uhfsensors/overview", text='UHF-Sensoren')
            
            section.margin-bottom
                p Adapterflansch für den UHF-DVS-50 Sensor, entwickelt zur Montage an Ablassventilen mit größeren Durchmessern. Der Lochkreis ist kompatibel mit DN50 und DN100. Gefertigt aus Aluminium. Erhältlich auf Anfrage.
                        
</template>

<script>
export default {
    meta: {
        de: {
            title: "BSS | UHF-Flansch-Adapter",
            description:
                "Adaptierungen für Ölschieber mit größerem Durchmesser",
        },
        en: {
            title: "BSS | UHF Flange Adapter",
            description: "Adapters for Drain Valves with Higher Diameter",
        },
    },
};
</script>

<style scoped lang='sass'>
</style>